<template>
  <div class="monitoringBox">
    <div class="top">
      <div class="content">
        <h3><center>运营小工具</center></h3>
        <ul>
          <li
            @mouseover="icon1Show = false"
            @mouseleave="icon1Show = true"
            @click="dialogVisible1 = true"
          >
            <div class="imgBox">
              <img src="./img/note.png" v-show="icon1Show" />
              <img src="./img/note1.png" v-show="!icon1Show" />
            </div>
            <p>用户保障查询</p>
          </li>
          <li @mouseover="icon5Show = false" @mouseleave="icon5Show = true">
            <router-link to="cmd_center/Offlinepolicy">
              <div class="imgBox">
                <img src="./img/nor.png" v-show="icon5Show" />
                <img src="./img/hover.png" v-show="!icon5Show" />
              </div>
              <p>线下保单查询</p>
            </router-link>
          </li>
          <li
            @mouseover="icon3Show = false"
            @mouseleave="icon3Show = true"
            @click="pathImFun1"
          >
            <div class="imgBox">
              <img src="./img/time.png" v-show="icon3Show" />
              <img src="./img/time1.png" v-show="!icon3Show" />
            </div>
            <p>历史案件</p>
          </li>
          <li
            @mouseover="icon4Show = false"
            @mouseleave="icon4Show = true"
            @click="pathImFun"
          >
            <div class="imgBox">
              <img src="./img/im.png" v-show="icon4Show" />
              <img src="./img/im1.png" v-show="!icon4Show" />
            </div>
            <p>用户IM管理</p>
          </li>
          <li @mouseover="icon2Show = false" @mouseleave="icon2Show = true">
            <router-link to="cmd_center/callCase1">
              <div class="imgBox">
                <img src="./img/iphone.png" v-show="icon2Show" />
                <img src="./img/iphone1.png" v-show="!icon2Show" />
              </div>
              <p>电话报案录入</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="centerBox">
      <span
        :class="{ active: caseIndex == 0 }"
        @click="
          caseIndex = 0;
          currentPage4 = 0;
          qcQuery();
        "
        >需回访确认（{{ needList0total }}）</span
      >
      <img src="./../../commonPage/img/line.png" class="line" />
      <span
        :class="{ active: caseIndex == 1 }"
        @click="
          caseIndex = 1;
          currentPage4 = 0;
          qcQuery1();
        "
        >已确认报案（{{ needList1total }}）</span
      >
    </div>
    <div class="content caseBox">
      <div class="top">
        <ul>
          <li>
            <p>案件来源</p>
            <input type="text" placeholder="案件来源" v-model="caseSource" />
          </li>
          <li>
            <p>关键字</p>
            <input type="text" placeholder="关键字" v-model="reportUser" />
          </li>
          <li class="btn">
            <button type="button" @click="getOrdinaryCase(caseIndex)">
              搜索
            </button>
            <button
              type="button"
              class="reset"
              @click="
                caseSource = '';
                reportUser = '';
                getOrdinaryCase(caseIndex);
              "
            >
              重置
            </button>
          </li>
        </ul>
      </div>
      <div class="table">
        <table width="100%" border="0" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th v-for="item in tableName">{{ item }}</th>
            </tr>
          </thead>
          <tbody v-if="needList0.length != 0 && caseIndex == 0">
            <tr v-for="(item, index) in needList0" v-if="item.generalLocation">
              <td>{{ item.obj.reportUser }}</td>
              <td>{{ item.obj.reporterContact }}</td>
              <td>{{ formattingTime(item.obj.reportTs) }}</td>
              <td v-if="item.victimList.length != 0">
                {{ item.victimList[0].obj.victimName }}
              </td>
              <td v-else>未填写</td>

              <td>
                <template
                  v-if="item.generalLocation.addr == item.generalLocation.name"
                >
                  <p>{{ setTxt(item.generalLocation.addr) }}</p>
                </template>
                <template v-else>
                  <p>{{ setTxt(item.generalLocation.addr) }}</p>
                  <p>
                    {{
                      item.generalLocation.name
                        ? setTxt(item.generalLocation.name)
                        : ""
                    }}
                  </p>
                </template>
              </td>
              <td>{{ item.obj.caseInsured == 2 ? "无保" : "在保" }}</td>
              <td>{{ item.obj.caseSrc }}</td>
              <td>{{ formattingTime(item.obj.updateAt) }}</td>
              <span
                style="line-height: 51px"
                v-if="item.helpOrder != '' && item.helpOrder != null"
              >
                <span
                  v-if="
                    item.helpOrder.extra != '' &&
                    item.helpOrder.extra != null &&
                    item.helpOrder.extra != undefined
                  "
                >
                  <td
                    width="200px"
                    v-if="
                      JSON.parse(item.helpOrder.extra).caseSrc != 'pingan' &&
                      JSON.parse(item.helpOrder.extra).caseSrc != 'xingcan' &&
                      JSON.parse(item.helpOrder.extra).caseSrc != '1' &&
                      JSON.parse(item.helpOrder.extra).caseSrc != '2' &&
                      JSON.parse(item.helpOrder.extra).caseSrc != '3'&&
                      JSON.parse(item.helpOrder.extra).caseSrc != '4'
                    "
                  >
                    {{ setTxt(item.obj.incidentDesc || "未填写") }}
                  </td>
                  <td width="200px" v-else>
                    {{ JSON.parse(item.helpOrder.extra).orderDesc || "未填写" }}
                  </td>
                </span>
              </span>
              <span style="line-height: 51px" v-else>
                <td width="200px">{{ "未填写" }}</td>
              </span>
              <!-- 100 马桶疏通
              200 开锁
              300 油烟机清洗
              310 油烟机拆洗
              400 保洁2小时
              410 保洁4小时
              500 擦玻璃小户型（100平米下）
              510 擦玻璃大户型（100-150平米） -->
              <td v-if="item.helpOrder != '' && item.helpOrder != null">
                <span
                  v-if="
                    item.helpOrder.extra != '' &&
                    item.helpOrder.extra != null &&
                    item.helpOrder.extra != undefined
                  "
                >
                  <span
                    v-if="JSON.parse(item.helpOrder.extra).serviceType == 100"
                    >马桶疏通</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 200
                    "
                    >开锁</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 300
                    "
                    >油烟机清洗</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 310
                    "
                    >油烟机拆洗</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 400
                    "
                    >保洁2小时</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 410
                    "
                    >保洁4小时</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 500
                    "
                    >擦玻璃小户型（100平米下）</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 510
                    "
                    >擦玻璃大户型（100-150平米）</span
                  >
                </span>
              </td>
              <td v-else></td>
              <td width="18%">
                <span v-if="item.helpOrder != '' && item.helpOrder != null">
                  <span
                    v-if="
                      item.helpOrder.extra != '' &&
                      item.helpOrder.extra != null &&
                      item.helpOrder.extra != undefined
                    "
                  >
                    <router-link
                      v-if="
                        JSON.parse(item.helpOrder.extra).caseSrc == 'pingan' ||
                        JSON.parse(item.helpOrder.extra).caseSrc == 'xingcan' ||
                        JSON.parse(item.helpOrder.extra).caseSrc == '1' ||
                        JSON.parse(item.helpOrder.extra).caseSrc == '2' ||
                        JSON.parse(item.helpOrder.extra).caseSrc == '3'||
                        JSON.parse(item.helpOrder.extra).caseSrc == '4'
                      "
                      :to="{
                        name: 'callCase1',
                        params: { caseList: item },
                        query: { typeId: 800, type: 1 },
                      }"
                      >确认信息</router-link
                    >
                    <!-- callCase1 -->
                    <router-link
                      v-else
                      :to="{ name: 'callCase2', params: { caseList: item } }"
                      >确认信息</router-link
                    >
                  </span>
                  <span v-else>
                    <router-link
                      :to="{ name: 'callCase2', params: { caseList: item } }"
                      >确认信息</router-link
                    >
                  </span>
                </span>
                <span v-else>
                  <router-link
                    :to="{ name: 'callCase2', params: { caseList: item } }"
                    >确认信息</router-link
                  >
                </span>

                <a
                  @click="
                    dialogVisible = true;
                    closeId = item.obj.id;
                  "
                  >关闭报案</a
                >
                <el-button
                  v-if="!item.generalLocation.latitude"
                  type="text"
                  disabled=""
                  >案件地图</el-button
                >
                <a v-if="item.generalLocation.latitude" @click="getGps(item)"
                  >案件地图</a
                >
              </td>
            </tr>
          </tbody>
          <tbody v-if="needList1.length != 0 && caseIndex == 1">
            <tr v-for="(item, index) in needList1" v-if="item.generalLocation">
              <td>{{ item.obj.reportUser }}</td>
              <td>{{ item.obj.reporterContact }}</td>
              <td>{{ formattingTime(item.obj.reportTs) }}</td>
              <td v-if="item.victimList.length != 0">
                {{ item.victimList[0].obj.victimName }}
              </td>
              <td v-else>未填写</td>
              <td>
                <p>{{ setTxt(item.generalLocation.addr) }}</p>
                <p>
                  {{
                    item.generalLocation.name
                      ? setTxt(item.generalLocation.name)
                      : ""
                  }}
                </p>
              </td>
              <td>{{ item.obj.caseInsured == 2 ? "无保" : "在保" }}</td>
              <td>{{ item.obj.caseSrc }}</td>
              <td>{{ formattingTime(item.obj.updateAt) }}</td>
              <td width="200px">{{ setTxt(item.obj.incidentDesc) }}</td>
              <td v-if="item.helpOrder != '' && item.helpOrder != null">
                <span
                  v-if="
                    item.helpOrder.extra != '' &&
                    item.helpOrder.extra != null &&
                    item.helpOrder.extra != undefined
                  "
                >
                  <span
                    v-if="JSON.parse(item.helpOrder.extra).serviceType == 100"
                    >马桶疏通</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 200
                    "
                    >开锁</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 300
                    "
                    >油烟机清洗</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 310
                    "
                    >油烟机拆洗</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 400
                    "
                    >保洁2小时</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 410
                    "
                    >保洁4小时</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 500
                    "
                    >擦玻璃小户型（100平米下）</span
                  >
                  <span
                    v-else-if="
                      JSON.parse(item.helpOrder.extra).serviceType == 510
                    "
                    >擦玻璃大户型（100-150平米）</span
                  >
                </span>
              </td>
              <td v-else></td>
              <td width="18%">
                <router-link
                  :to="
                    item.helpOrder &&
                    item.helpOrder.extra &&
                    JSON.parse(item.helpOrder.extra).caseSrc == 'pingan' &&
                    JSON.parse(item.helpOrder.extra).caseSrc == '1'
                      ? {
                          name: 'Familywealth',
                          params: { flag: false, caseList: item },
                          query: { caseId: item.obj.id, typeId: 800, creat: 1 },
                        }
                      : { name: 'creatCase', query: { caseId: item.obj.id } }
                  "
                  >创建案件</router-link
                >
                <!-- <router-link
                  :to="{ name: 'newstar1', params: { caseList: item } }"
                  >补充信息</router-link
                > -->
                <!-- <a @click="dialogVisible= true;closeId=item.obj.id">关闭</a><br/> -->
                <el-button
                  v-if="!item.generalLocation.latitude"
                  type="text"
                  disabled=""
                  >案件地图</el-button
                >
                <a v-if="item.generalLocation.latitude" @click="getGps(item)"
                  >案件地图</a
                >
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="needList0.length == 0 && caseIndex == 0" class="noRecord">
          暂无记录
        </p>
        <p v-if="needList1.length == 0 && caseIndex == 1" class="noRecord">
          暂无记录
        </p>
      </div>
      <el-pagination
        v-if="id == 0"
        style="margin-top: 15px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[20]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="needList0total"
      >
      </el-pagination>
      <el-pagination
        v-else
        style="margin-top: 15px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[20]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="needList1total"
      >
      </el-pagination>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确认关闭？</span>
      <textarea
        placeholder="请输入关闭原因"
        v-model="closeTxt"
        class="closeTxt"
      >
      </textarea>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            dialogVisible = false;
            closeOrdinaryCase(closeId);
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="查询保单"
      :visible.sync="dialogVisible1"
      width="960px"
      center
    >
      <searchBd></searchBd>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- GPS -->
    <div class="gpsBox" :style="{ visibility: gpsBox ? 'initial' : 'hidden' }">
      <gpsBox
        ref="gpsBox"
        @getGpshid="getGpshid"
        @getGpshid1="getGpshid1"
      ></gpsBox>
    </div>
  </div>
</template>

<script>
import { getOrdinaryCase, closeOrdinaryCase } from "@/views/axios/api.js";
import constants from "@/util/constants.js";
import searchBd from "./searchBd";
import gpsBox from "@/views/map/searchMap.vue";
export default {
  data() {
    return {
      needList0total: 0,
      needList1total: 0,
      id: 0,
      total: 0,
      start: 0,
      count: 20,
      currentPage4: 0,
      caseIndex: 0,
      dialogVisible: false,
      dialogVisible1: false,
      icon1Show: true,
      icon2Show: true,
      icon3Show: true,
      icon4Show: true,
      icon5Show: true,
      tableName: [
        "报案用户",
        "用户手机号",
        "报案时间",
        "出险人",
        "出险地",
        "出险人保障",
        "案件来源",
        "确认时间",
        "事故经过",
        "服务类型",
        "操作",
      ],
      needList0: [], //需要回访数据
      needList1: [], //已确认回访
      closeId: "",
      caseSource: "", //案件来源
      reportUser: "",
      closeTxt: "",
      token: JSON.parse(window.localStorage.getItem("data")).data,
      gpsBox: false,
    };
  },
  components: {
    searchBd,
    gpsBox,
  },
  mounted() {
    if (this.$route.query.location == 2) {
      this.caseIndex = 1;
    }
    this.getOrdinaryCase(0);
    this.getOrdinaryCase(1);
  },
  methods: {
    qcQuery1() {
      console.log(123);
      this.currentPage4 = 0;
      this.start = 0;
      this.count = 20;
      this.id = 1;
      this.getOrdinaryCase(1);
    },
    handleSizeChange(val) {
      this.count = val;
      console.log(this.id);
      if (this.id == 0) {
        this.getOrdinaryCase(0);
      } else {
        this.getOrdinaryCase(1);
      }
    },
    handleCurrentChange(val) {
      this.start = (val - 1) * this.count;
      if (this.id == 0) {
        this.getOrdinaryCase(0);
      } else {
        this.getOrdinaryCase(1);
      }
    },
    setTxt(str, status) {
      if (constants.setTxt(str, status)) {
        return constants.setTxt(str, status);
      } else {
        return str;
      }
    },
    formattingTime(time) {
      return constants.time(time);
    },
    getOrdinaryCase(id) {
      // this.id = id
      var data = {
        token: this.token,
        confirmed: id,
        start: this.start,
        count: this.count,
        caseSrc: this.caseSource,
        reportUser: this.reportUser,
      };
      getOrdinaryCase(data)
        .then((res) => {
          console.log(res.data);
          if (id == 0) {
            this.needList0 = res.data.obj;
            this.needList0total = res.data.total;
          } else {
            this.needList1 = res.data.obj;
            this.needList1total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeOrdinaryCase(caseId) {
      var data = {
        token: this.token,
        caseId,
        state: 116,
        text: this.closeTxt,
      };
      closeOrdinaryCase(data)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "关闭成功！",
              type: "success",
            });
            this.getOrdinaryCase(0);
            this.getOrdinaryCase(1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    qcQuery() {
      this.currentPage4 = 0;
      this.start = 0;
      this.count = 20;
      this.id = 0;
      this.getOrdinaryCase(0);
      this.$router.push({
        path: "/monitoring",
      });
    },
    pathImFun() {
      window.open("http://www.dajiuxing.com.cn/im/index.html");
    },
    pathImFun1() {
      this.$router.push({
        path: "/creatNav/consultingCase?caseType=1&status=2",
      });
    },

    getGps(data) {
      this.gpsBox = true;
      // this.$refs.changeLanguage.setBtn()
      console.log(data);
      var objectData = {
        addr: data.generalLocation.addr,
        latitude: data.generalLocation.latitude,
        longitude: data.generalLocation.longitude,
      };
      this.$refs.gpsBox.parendZx(objectData);
      document.getElementsByTagName("body")[0].style.height = "100vh";
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    },

    getGpshid(data, data1) {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      if (data.lat == "") return;
      this.reportcase.latitude = data.lat;
      this.reportcase.longitude = data.lng;
      this.reportcase.addr = data.address;
      if (data1 == undefined)
        return this.$message.error("地址未自动匹配，请手动添加！");
      if (data1.country == "中国") {
        this.reportcase.nation = "+86";
      } else {
        this.countries.forEach((item) => {
          if (item.label == data1.country) {
            this.reportcase.nation = item.value;
          }
        });
      }
      this.loadcounties(data1, true);
    },
    getGpshid1() {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    },
  },
};
</script>

<style scoped="scoped">
* {
  outline: none;
}
a {
  text-decoration: none;
  color: #333;
}
.content {
  width: 1200px;
  margin: 0 auto;
}
.monitoringBox > .top {
  background: white;
  padding-top: 40px;
}
.monitoringBox > .top ul {
  overflow: hidden;
  padding: 60px 0 30px 0;
}
.monitoringBox > .top ul li {
  float: left;
  width: 20%;
  text-align: center;
  cursor: pointer;
}
.monitoringBox > .top ul li p {
  padding: 20px 0;
}
.monitoringBox > .top ul li .imgBox {
  height: 94px;
  width: 94px;
  margin: 0 auto;
}
.monitoringBox > .top ul li .imgBox img {
  display: block;
  margin: 0 auto;
}
.monitoringBox > .top ul li .imgBox img:first-child {
  padding: 7px 0;
}
.centerBox {
  text-align: center;
  padding-bottom: 30px;
  padding: 30px 0;
}
.centerBox span {
  padding: 0 10px;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  line-height: 50px;
  display: inline-block;
  vertical-align: middle;
}
.centerBox span:first-child {
  margin-right: 10px;
}
.centerBox span:last-child {
  margin-left: 10px;
}
.centerBox span.active {
  color: #00abfa;
  border-bottom: 2px solid #00abfa;
}
.centerBox .line {
  vertical-align: middle;
}
.caseBox {
  background-color: white;
  border-radius: 5px;
  padding: 20px 15px;
}
.caseBox > .top ul {
  overflow: hidden;
}
.caseBox > .top ul li {
  float: left;
  width: 33.3%;
  overflow: hidden;
}
.caseBox > .top ul li p {
  float: left;
  line-height: 30px;
  margin-right: 20px;
}
.caseBox > .top ul li input {
  float: left;
  width: 200px;
  border: 1px solid #999;
  height: 30px;
  padding: 0 10px;
  border-radius: 3px;
}
.btn button {
  width: 100px;
  height: 30px;
  background: #00abfa;
  border: none;
  color: white;
  cursor: pointer;
}
.btn button.reset {
  background: #ccc;
  color: #333;
}
.table {
  margin-top: 30px;
  border: 1px solid #d9ddde;
  border-right: none;
  border-bottom: none;
}
.table thead {
  background: #f5f7fb;
  color: #333;
}
.table th {
  font-size: 14px;
  color: #333;
  height: 50px;
  border-bottom: 1px solid #d9ddde;
  border-right: 1px solid #d9ddde;
}

.table td {
  border-bottom: 1px solid #d9ddde;
  border-right: 1px solid #d9ddde;
  text-align: center;
  font-size: 12px;
  height: 50px;
  word-wrap: break-word;
  padding: 0 5px;
}
.table a {
  text-decoration: none;
  color: #00abfa;
  padding: 0 5px;
  cursor: pointer;
}
.noRecord {
  text-align: center;
  line-height: 100px;
  border-right: 1px solid #d9ddde;
  color: #666;
  border-bottom: 1px solid #d9ddde;
}
.gpsBox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: powderblue;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/monitoringCase/index.vue